import { render, staticRenderFns } from "./RequestDetailsManageResponses.vue?vue&type=template&id=0159a483"
import script from "./RequestDetailsManageResponses.vue?vue&type=script&lang=js"
export * from "./RequestDetailsManageResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports